<template>
  <v-card
    :color="
      selectedOffer &&
      typeof selectedOffer === 'object' &&
      selectedOffer.offers_id &&
      typeof selectedOffer.offers_id === 'object' &&
      selectedOffer.offers_id.color_scheme &&
      typeof selectedOffer.offers_id.color_scheme === 'object' &&
      selectedOffer.offers_id.color_scheme.background_color &&
      typeof selectedOffer.offers_id.color_scheme.background_color ===
        'object' &&
      selectedOffer.offers_id.color_scheme.background_color.id
        ? selectedOffer.offers_id.color_scheme.background_color.id
        : 'surface-light'
    "
    :theme="
      selectedOffer &&
      typeof selectedOffer === 'object' &&
      selectedOffer.offers_id &&
      typeof selectedOffer.offers_id === 'object' &&
      selectedOffer.offers_id.color_scheme &&
      typeof selectedOffer.offers_id.color_scheme === 'object' &&
      selectedOffer.offers_id.color_scheme.theme
        ? selectedOffer.offers_id.color_scheme.theme
        : undefined
    "
    max-width="480"
    rounded="xl"
  >
    <div class="d-flex align-center justify-space-between px-3 py-1">
      <v-btn
        v-if="Array.isArray(offers) && offers.length > 1 && !isSubmitted"
        :append-icon="mdiArrowRight"
        :disabled="isPending"
        aria-label="Next Offer"
        class="text-none"
        color="red-darken-2"
        flat
        rounded="pill"
        size="small"
        @click="nextOffer"
        >See Next Offer</v-btn
      >
      <div v-else />
      <v-btn
        :icon="mdiClose"
        aria-label="Close Offers"
        variant="text"
        @click="$emit('close')"
      />
    </div>

    <OfferContent
      v-if="
        selectedOffer &&
        typeof selectedOffer === 'object' &&
        selectedOffer.offers_id &&
        typeof selectedOffer.offers_id === 'object'
      "
      :key="selectedOffer.offers_id.id"
      :offer="selectedOffer.offers_id"
      @submit="isSubmitted = true"
    />
  </v-card>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useOffersOrThrow } from '#root/lib/useOffers'
import { mdiArrowRight, mdiClose } from '@mdi/js'

const { isPending, nextOffer, offers, selectedOffer } = useOffersOrThrow()
const isSubmitted = ref(false)

defineEmits(['close'])
</script>
